<!-- //中间栏模块 -->
<template>
  <div class="sidebar_left">
    <div class="contrl_item" @click="handleChangeControlModel" :class="{ active_plat: chatModel == 2 }">
      <div style="position: relative;display: flex;flex-direction: column;align-items: center;">
        <span class="ico"><i style="font-weight: bold;" class="iconfont icon-xiaoxi2"></i>
        </span>
        <div style=" writing-mode: vertical-rl;letter-spacing: 3px;">
          全部
        </div>
        <em class="m_vui__badge" style="right: 0;top:-10px"
          v-if="chatModel == 2 && contrlMsgCount > 0">{{ contrlMsgCount }}<span v-if="contrlMsgCount == 999">+</span></em>
      </div>
    </div>


    <div v-for="item in menuList" :key="item.value" style="width:100%">
      <div v-if="item.checked" class="item" :class="{ active_plat: chatingPlatId == item.value && chatModel == 1 }"
        @click="handleGetAccountList(item.value)">
        <div class="item_inner" style="position: relative">
          <i class="iconfont" :class="[item.icon, item.colorClass]"></i>
          {{ item.desc }}
          <em class="m_vui__badge" v-if="item.value == 1 && douyinNewMsgCount > 0 && chatModel == 1">{{
            douyinNewMsgCount }}</em>
          <em class="m_vui__badge" v-else-if="item.value == 2 && xiaoHsMsgCount > 0 && chatModel == 1">{{ xiaoHsMsgCount
            }}</em>
          <em class="m_vui__badge" v-else-if="item.value == 3 && webH5MsgCount > 0 && chatModel == 1">{{ webH5MsgCount
            }}</em>
          <em class="m_vui__badge" v-else-if="item.value == 4 && weixinMsgCount > 0 && chatModel == 1">{{ weixinMsgCount
            }}</em>
          <em class="m_vui__badge" v-else-if="item.value == 5 && kuaishouMsgCount > 0 && chatModel == 1">{{
            kuaishouMsgCount }}</em>
          <em class="m_vui__badge" v-else-if="item.value == 10 && laikeimMsgCount > 0 && chatModel == 1">{{
            laikeimMsgCount }}</em>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
// 引入动态组件（中间栏）
import { toRefs, onMounted, computed, reactive, ref, inject } from "vue";
import { getAccountList } from "@/api/chatapi";
import { useStore } from "vuex";
import { ElNotification } from "element-plus";
import { CHAT_MDOEL } from '@/constants/common-const'
import { getCtrlAccountFriendList } from "@/api/chatapi";
import { SELECT_FRIEND_LIMIT } from '@/constants/common-const';
export default {
  components: {},
  setup() {
    let store = useStore();

    const smartEnumPlugin = inject("smartEnumPlugin");

    const platIdRef = ref(undefined);

    const menuList = computed(() => {
      return store.state.user.user_plat_msg_menu
    })

    const contrlMsgCount = computed(() => {
      let list = store.state.chat_store.ctrl_friend_list || []
      let count = list.reduce((t, item) => {
        return t + item.new_msg_count
      }, 0)
      if (count > 1000) {
        return 999
      } else {
        return count
      }
    })
    //当前选中平台
    const chatingPlatId = computed(() => {
      return store.state.chat_store.chat_plat_id
    });

    //douyin未读消息数
    const douyinNewMsgCount = computed(() => {
      let c = store.state.chat_store.douyinNewMsgCount;
      return c > 999 ? 999 : c;
    });
    //小红书未读消息数
    const xiaoHsMsgCount = computed(() => {
      let c = store.state.chat_store.xiaoHsMsgCount;
      return c > 999 ? 999 : c;
    });
    //webh5未读消息数
    const webH5MsgCount = computed(() => {
      let c = store.state.chat_store.webH5NewMsgCount;
      return c > 999 ? 999 : c;
    });
    //微信未读消息数
    const weixinMsgCount = computed(() => {
      let c = store.state.chat_store.weixinMsgCount;
      return c > 999 ? 999 : c;
    });
    //快手未读消息数
    const kuaishouMsgCount = computed(() => {
      let c = store.state.chat_store.kuaishouMsgCount;
      return c > 999 ? 999 : c;
    });
    //来客IM未读消息数
    const laikeimMsgCount = computed(() => {
      let c = store.state.chat_store.laikeimMsgCount;
      return c > 999 ? 999 : c;
    });

    const data = reactive({});
    function handleGetAccountList(platId) {
      platIdRef.value = platId;
      // ~~~~~~~~~~~~~~~~~~~ 新缓存 ~~~~~~~~~~~~~~~~~~~~~~~~
      store.dispatch('chat_store/doSetChatPlat', platId)
      handleChangeChatModel(CHAT_MDOEL.PLAT_FORM.value)
      // ~~~~~~~~~~~~~~~~~~~ end 新缓存 ~~~~~~~~~~~~~~~~~~~~~~~~
      getAccountList({ plat_type: platId });
    }


    const handleChangeControlModel = async () => {
      handleChangeChatModel(CHAT_MDOEL.CONTROL.value)

      store.commit('chat_store/setctrlFriendListLoading', true)
      store.dispatch('chat_store/doSetChatPlat', -1)
      //获取账号好友列表
      getCtrlAccountFriendList({ aid: 0, limit: SELECT_FRIEND_LIMIT, log_id: 0 })
    }
    /**
   * 切换对话模式
   */
    const handleChangeChatModel = async (model) => {
      store.commit('chat_store/changehatModel', model)
    }
    /**
   * 对话模式，控制台模式/平台模式
   */
    const chatModel = computed(() => {
      return store.state.chat_store.chat_model
    })
    onMounted(() => {
      if (CHAT_MDOEL.PLAT_FORM.value == chatModel.value) {
        //获取显示的平台第一项
        let idx = menuList.value?.findIndex(item => item.checked)
        //默认抖音
        if (idx >= 0) {
          handleGetAccountList(menuList.value[idx].value);
        }
      } else {
        //控制台模式
        handleChangeControlModel()
      }

    });
    return {
      douyinNewMsgCount,
      xiaoHsMsgCount,
      webH5MsgCount,
      weixinMsgCount,
      kuaishouMsgCount,
      laikeimMsgCount,
      smartEnumPlugin,
      menuList,
      chatModel,
      contrlMsgCount,
      ...toRefs(data),
      handleGetAccountList,
      chatingPlatId,
      handleChangeChatModel,
      handleChangeControlModel,
    };
  },
};
</script>

<style lang="scss" scoped>
.contrl_item {
  cursor: pointer;
  width: 100%;
  padding: 15px 0;
  font-weight: 600;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.m_vui__badge {
  display: flex;
  justify-content: center;
  align-items: center;
  writing-mode: horizontal-tb;
  position: absolute;
  letter-spacing: normal;
  max-width: 20px;
  overflow: hidden;
  top: -6px;
  right: -6px;
  z-index: 998;
}

.active_plat {
  //color: #0aea64 !important;
  color: white !important;
  background-image: linear-gradient(180deg, #2e2f2f, #3a3535) !important;
}

.sidebar_left {
  // position:absolute;
  // left: -35px;
  // top:0;
  // display: inline-block;
  background-color: rgba(24, 24, 24, 0.8);
  position: relative;
  width: 35px;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 5px 0 0 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  // border-radius: 3px 0 0 3px;
  height: 100%;

  .item_inner {
    padding-top: 10px;
  }

  .item {
    // padding-top: 5px;
    padding: 10px 0;
    align-self: center;
    color: white;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    // height: 120px;
    width: 100%;
    writing-mode: vertical-rl;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: rgba(255, 255, 255, 0.6);
    letter-spacing: 3px;

    .icons {
      position: absolute;
      top: 5px;
    }

    .item_t {
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }

    .item_b {
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    //
    // background-image: url('@assets/img/dy.png');
  }

  // .item_bottom{
  //   position:absolute;
  //   bottom: 0;
  //   width: 100%;
  //   height: 5px;
  //   background-color: #0aea64;

  // }

  .item_p {
    // padding-top:10px;
  }

  // .item1{
  //   background-image: url('~@/assets/img/dy.png');
  //   background-repeat: no-repeat;
  // }
  .item:hover {
    color: rgba(255, 255, 255, 0.9);
    background-color: rgba(46, 47, 47, 0.9);
  }

  .ky {
    // background-image: url('@/assets/img/dy.png');
  }
}
</style>